<script setup>
import ButtonLink from '@/Components/Buttons/ButtonLink.vue';
import Card from '@/Components/Card.vue';
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import { inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const bg = useBg();
const target = ref(null);
useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    // isIntersecting ? bg.add('projects') : bg.remove('projects');
});

const props = defineProps({
    title: String,
    projects: Object,
    amount_projects: String,
});

const route = inject('route');
const { t } = useI18n();
</script>

<template>
    <div ref="target" class="container my-15 md:my-30" v-if="projects">
        <div class="flex justify-center">
            <h2 class="text-2xl lg:text-[64px] font-bold mb-8 md:mb-16">Projecten</h2>
        </div>

        <div class="grid gap-8 md:gap-16 md:grid-cols-3">
            <Card
                v-for="project in projects"
                :type="project"
                :href="route('public.projects.show', { slug: project.page_slug })"
                :id="project.id"
            />
        </div>

        <div class="flex justify-center mt-8 md:mt-16">
            <ButtonLink :label="$t('Alle projects')" :href="route('public.projects.index')" />
        </div>
    </div>
</template>
